export default __webpack_public_path__ + "static/media/ppt1_intro.a8515c09.png";